
import { connect } from "react-redux";
import { UserComponent } from "./user";
import { setAccountState } from "../../login/login/actions";
import { dataToStore } from "../../onboarding/actions";
import { dwollaUpdate } from "../../payment/actions";
import { tdaUpdate } from "../../tda/actions";
import { navigatePath } from "../../nav/actions";
import { updateUserAcctIndex } from "../../login/login/actions";
import {addUGMAInvite, loadAccountData, loadUGMADashboard, setUGMAItem} from "../../dashboard/user/actions";
import { LoadChats } from "../../chat/actions";
import {GetPaymentInformation} from "../PaymentsDashboard/action";
import {loadUserSecurityItems} from "../../superadmin/security-purchase-reducer";

const mapDispatchToProps = dispatch => {
  return {
    setAccountState: (account_state, index, token, onboarding_token) => dispatch(
      setAccountState(account_state, index, token, onboarding_token)),
    dataToStore: (data, index) => dispatch(dataToStore(data, index)),
    dwollaUpdate: (data, index) => dispatch(dwollaUpdate(data, index)),
    tdaUpdate: (data, index) => dispatch(tdaUpdate(data, index)),
    navigatePath: (path, args) => dispatch(navigatePath(path, args)),
    updateUserAcctIndex: acct_index => dispatch(updateUserAcctIndex(acct_index)),
    loadAccountData:
      (username, acct_index, date, chart_colors) => dispatch(loadAccountData(username, acct_index, date, chart_colors)),
    loadChats: continuations => dispatch(LoadChats(continuations)),
    loadUGMADashboard: (username, acct_index, wlf_id) => dispatch(
      loadUGMADashboard(username, acct_index, wlf_id)),
    addUGMAInvite: (username, index, item_index) => dispatch(
      addUGMAInvite(username, index, item_index)),
    setUGMAItem: (username, index, item) => dispatch(setUGMAItem(username, index, item)),
    GetPaymentInformation: username => dispatch(GetPaymentInformation(username)),
    loadUserSecurityItems: (username) => dispatch(loadUserSecurityItems(username)),
  }
};

const mapStateToProps = state => {
  return {
    token: state.user && state.user.token,
    onboarding_token: state.user && state.user.onboarding_token,
    config: state.app.config,
    client: state.client,
    user: state.user,
    userDashboard: state.userDashboard,
    onboarding: state.onboarding,
    tda: state.tda,
    dwolla: state.dwolla,
    app: state.app,
    inbox: state.inbox,
    chat: state.chat,
    userPayments: state.userPayments,
    securityPurchase: state.securityPurchase,
    wlfs: state.wlfs,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserComponent);
